<a
  *ngIf="!isDialog"
  href="javascript:void(0)"
  (click)="showModal()"
  class="img-preview"
  id="img-file-{{ id }}"
  [attr.aria-label]="('PREVIEW' | translate) + ': ' + imgName"
  [title]="('PREVIEW' | translate) + ': ' + imgName"
>
  <i
    *ngIf="isHeic"
    class="pi pi-image kuba-document-icon"
    aria-hidden="true"
  ></i>
  <img *ngIf="!isHeic" [src]="imgSrc" [alt]="imgName" />
</a>

<div class="img-modal" *ngIf="showModalWindow" id="img-pop-{{ id }}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4>
          <span class="ic-sm">
            <i class="pi pi-image" aria-hidden="true"></i>
          </span>
          <span>
            {{ imgName }}
          </span>
        </h4>
        <button
          type="button"
          (click)="hideModal()"
          class="close"
          [attr.aria-label]="'CLOSE' | translate"
        >
          <span class="icon ic-md icon-multiply"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="file-preview-wrapper">
          <div class="file-preview-box">
            <p
              *ngIf="isLoading"
              role="status"
              [translate]="'ATTACHMENT_PREVIEW.LOADING'"
            ></p>
            <p
              *ngIf="previewFailed"
              role="alert"
              [translate]="'ATTACHMENT_PREVIEW.UNAVAILABLE'"
            ></p>
            <img
              *ngIf="previewSrc && !previewFailed"
              [src]="previewSrc"
              [alt]="imgName"
              (error)="previewFailed = true"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer" *ngIf="isHeic || previewFailed">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="downloadOriginal()"
          [translate]="'ATTACHMENT_PREVIEW.DOWNLOAD_ORIGINAL'"
        ></button>
      </div>
    </div>
  </div>
</div>
